const defaultSeparator = /__|_|-|\s+/g;

export const camelize = (
  str: string,
  separator: string | RegExp = defaultSeparator
) => {
  const separatorRegex =
    typeof separator === "string"
      ? new RegExp(`[${separator}]+`, "g")
      : separator;

  return str
    .split(separatorRegex)
    .map((word, index, words) => {
      if (words.length === 1) {
        return word.charAt(0).toLocaleLowerCase() + word.slice(1);
      }

      return index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("");
};
